import { connect } from 'react-redux';

import type { RootReducerStateT } from 'app/reducers/rootReducer';

import UrlTriggerModal from '../../components/modals/url';
import type { URLTriggerModalFormValuesT } from '../../components/modals/url';
import type { FlowChatNodeURLTriggerT } from '../../components/nodeTypes/url';

export type URLTriggerModalStatePropsT = {
  initialValues: URLTriggerModalFormValuesT;
  payload: URLTriggerModalFormValuesT;
};

const mapStateToProps = (
  _state: RootReducerStateT,
  ownProps: { node: FlowChatNodeURLTriggerT },
): URLTriggerModalStatePropsT => {
  let payload: URLTriggerModalFormValuesT = {
    urls: [
      {
        value: '',
        label: '',
      },
    ],
    defaultUrl: '',
  };

  if (ownProps.node.payload !== null) {
    payload = {
      urls: [],
      defaultUrl: ownProps.node.payload.defaultUrl,
    };
    for (const urlIndex in ownProps.node.payload.urls) {
      payload.urls.push({
        value: ownProps.node.payload.urls[urlIndex],
        label: urlIndex,
      });
    }
  }

  return {
    payload,
    initialValues: payload,
  };
};

export default connect(mapStateToProps)(UrlTriggerModal);
